import React from 'react';
import { getPrivateThanksConfig } from '../../../config/privateBooking';

const HncThanks = () => {
  const thanksConfig = getPrivateThanksConfig();
  return <thanksConfig.thanksComponent />;
};
export default HncThanks;
